import React, { useEffect, useState } from "react";
import API from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ADS_MODE } from "@/config/ads";

const EMPTY = { name: "", image_url: "", link_url: "", category: "", starts_at: "", ends_at: "", placements: ["home", "list", "detail"] };
const PLACES = [["home", "Home"], ["list", "Lista bisogni"], ["detail", "Dettaglio bisogno"]];

export function AdminAdsPanel() {
  const { categories, catName } = useApp();
  const [ads, setAds] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = () => API.get("/admin/ads").then((r) => setAds(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const togglePlace = (p) => setF({ ...f, placements: f.placements.includes(p) ? f.placements.filter((x) => x !== p) : [...f.placements, p] });
  const save = async () => {
    if (!f.name || !f.image_url || !f.link_url || !f.starts_at || !f.ends_at) return toast.error("Compila nome, immagine, link e date");
    try {
      await API.post("/admin/ads", { ...f, category: f.category || null });
      toast.success("Banner salvato"); setF(EMPTY); load();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Controlla link (https://) e date");
    }
  };
  const toggle = async (id) => { await API.put(`/admin/ads/${id}/toggle`); load(); };
  const remove = async (id) => { if (!window.confirm("Eliminare questo banner?")) return; await API.delete(`/admin/ads/${id}`); load(); };

  return (
    <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5 mb-4" data-testid="admin-ads">
      <h2 className="font-semibold text-[#0F1230] mb-1">Banner pubblicitari interni (sponsor)</h2>
      <p className="text-xs text-[#4A4E68] mb-3">Si vedono solo con ADS_MODE = "sponsor" (ora: <b data-testid="ads-mode-value">{ADS_MODE}</b>). Interruttore in frontend/src/config/ads.js.</p>
      <div className="grid sm:grid-cols-2 gap-2 mb-2">
        <Input data-testid="ad-name" placeholder="Nome attività" value={f.name} onChange={set("name")} />
        <Input data-testid="ad-link" placeholder="Link (https://...)" value={f.link_url} onChange={set("link_url")} />
        <Input data-testid="ad-image" placeholder="URL immagine" value={f.image_url} onChange={set("image_url")} className="sm:col-span-2" />
        <label className="text-xs text-[#4A4E68]">Inizio<Input data-testid="ad-start" type="date" value={f.starts_at} onChange={set("starts_at")} /></label>
        <label className="text-xs text-[#4A4E68]">Fine<Input data-testid="ad-end" type="date" value={f.ends_at} onChange={set("ends_at")} /></label>
        <select data-testid="ad-category" value={f.category} onChange={set("category")} className="h-10 rounded-md border border-[#DADFEA] px-2 text-sm sm:col-span-2">
          <option value="">Tutte le categorie</option>
          {categories.map((c) => <option key={c.slug} value={c.slug}>{catName(c)}</option>)}
        </select>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        {PLACES.map(([k, l]) => (
          <button key={k} data-testid={`ad-place-${k}`} onClick={() => togglePlace(k)} className={`px-3 h-8 rounded-full text-xs font-bold border ${f.placements.includes(k) ? "bg-[#1F4FE0] text-white border-[#1F4FE0]" : "border-[#DADFEA]"}`}>{l}</button>
        ))}
      </div>
      <Button data-testid="ad-save" onClick={save} className="bg-[#1F4FE0] text-white rounded-full">Salva banner</Button>
      <div className="mt-4 space-y-2">
        {ads.map((a) => (
          <div key={a.id} data-testid={`ad-row-${a.id}`} className="flex items-center gap-2 text-sm border-t border-[#EEF1F7] pt-2">
            <span className="flex-1 min-w-0 truncate"><b>{a.name}</b> · {a.starts_at} → {a.ends_at} · {a.category || "tutte"}</span>
            <button data-testid={`ad-toggle-${a.id}`} onClick={() => toggle(a.id)} className="text-xs font-bold text-[#1F4FE0]">{a.active ? "Disattiva" : "Attiva"}</button>
            <button data-testid={`ad-delete-${a.id}`} onClick={() => remove(a.id)} className="text-xs font-bold text-[#E8590C]">Elimina</button>
          </div>
        ))}
      </div>
    </div>
  );
}
